import React from 'react';

import { createRoot } from "react-dom/client";
import App from './App';
import './i18n/i18n';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

createRoot(document.getElementById('root')).render(rootElement);

// Register service worker for caching assets (videos, images)
serviceWorkerRegistration.register();